import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { Link } from '@inertiajs/react';
import ChevronRight from './icons/ChevronRight';
const baseItemStyle = css `
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 38px;
    min-height: 38px;
    background-color: ${props => props.isActive ? props.theme.secondary : 'transparent'};
    color: ${props => (props.isActive ? '#ffffff' : props.theme.primary.base)};
    font-weight: ${props => (props.isActive ? '700' : '600')};
    margin: 0 5px;
    text-decoration: none;
    border-radius: 6px;
    transition: all 100ms ease-in-out;

    &:hover {
        svg {
            fill: ${props => props.href ? props.theme.secondary : props.theme.primary};
        }
    }

    ${props => props.disabled &&
    css `
            pointer-events: none;
            opacity: 0.5;
        `}

    &:first-child,
    &:last-child {
        background-color: transparent;
        color: transparent;
        border-radius: 3px;
        min-width: 34px;
        overflow: hidden;
    }

    &:last-child {
        margin-right: 0;
    }
`;
const StyledPaginationLinkItem = styled(Link).withConfig({
    shouldForwardProp: (prop, defaultValidatorFn) => !['isActive'].includes(prop) && defaultValidatorFn(prop),
}) `
    ${baseItemStyle};

    &:hover {
        color: ${props => (props.isActive ? '#ffffff' : props.theme.secondary)};
    }
`;
const StyledPaginationItem = styled.span.withConfig({
    shouldForwardProp: (prop, defaultValidatorFn) => !['isActive'].includes(prop) && defaultValidatorFn(prop),
}) `
    ${baseItemStyle};
`;
const StyledChevronRight = styled(ChevronRight) `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 5px;
    min-width: 5px;
    height: 9px;
    fill: ${props => props.theme.primary.base};
`;
const StyledChevronLeft = styled(ChevronRight) `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(180deg);
    width: 5px;
    min-width: 5px;
    height: 9px;
    fill: ${props => props.theme.primary.base};
`;
const PaginationItem = ({ label, isFirst, isLast, href, ...restProps }) => {
    let shortLabel = label;
    if (isFirst || isLast) {
        shortLabel = undefined;
    }
    if (href) {
        let longLabel;
        if (isNaN(Number(label))) {
            longLabel = `Ga naar de ${label}`;
        }
        else {
            longLabel = `Pagina ${label}`;
        }
        return (_jsxs(StyledPaginationLinkItem, { "aria-label": longLabel, href: href, isFirst: isFirst, isLast: isLast, ...restProps, children: [shortLabel, isFirst && _jsx(StyledChevronLeft, {}), isLast && _jsx(StyledChevronRight, {})] }));
    }
    return (_jsxs(StyledPaginationItem, { ...restProps, children: [shortLabel, isFirst && _jsx(StyledChevronLeft, {}), isLast && _jsx(StyledChevronRight, {})] }));
};
export default PaginationItem;
